import useNotifier from 'Notifications/useNotifier'

export default function Notifications() {
  useNotifier()

  return null
}
